import { render, staticRenderFns } from "./SingleMailgunTemplate.vue?vue&type=template&id=4b781794&scoped=true&"
import script from "./SingleMailgunTemplate.vue?vue&type=script&lang=js&"
export * from "./SingleMailgunTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SingleMailgunTemplate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleMailgunTemplate.vue?vue&type=style&index=1&id=4b781794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b781794",
  null
  
)

export default component.exports